<template>
    <div style="width: 100%; height: 300px;">
        <div id="selfdetailmain" style="width: 100%; height: 100%;"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import Http from "../../src/apis/statistics";
export default {
    name: 'selfChartDetailComponent',
    props: {
        plan_id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            myChart: null,
            resizeHandler: null
        }
    },
    
    mounted() {
        this.$nextTick(() => {
            this.initChart();
        });
        
        this.resizeHandler = () => {
            if (this.myChart) {
                this.myChart.resize();
            }
        };
        window.addEventListener('resize', this.resizeHandler);
        this.workLineChart()
    },
    
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler);
        if (this.myChart) {
            this.myChart.dispose();
            this.myChart = null;
        }
    },
    watch: {
        state(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.workLineChart()
            }
        }
    },
    methods: {
        workLineChart(){


            Http.selfStudyDetailChart({plan_id:this.plan_id}).then((res) => {
                this.initChart(res.data)
            });

            
        },
        initChart(data) {
            if (this.myChart) {
                this.myChart.dispose();
            }

            const chartDom = document.getElementById('selfdetailmain');
            if (!chartDom) {
                console.error('未找到图表容器');
                return;
            }

            this.myChart = echarts.init(chartDom);

            // 处理数据为空的情况
            const dates = data?.dates || [];
            const counts = data?.values || [];

            const option = {
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                tooltip: {
                    trigger: 'axis',
                    show: true,
                    backgroundColor: 'rgba(0,0,0,0.7)',
                    textStyle: { color: '#fff' }
                },
                xAxis: {
                    type: 'category',
                    data: dates
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    type: 'line',
                    data: counts,
                    symbol: 'circle',
                    symbolSize: 6
                }]
            };

            this.myChart.setOption(option);
        }
    }
};
</script>